import styled from 'styled-components';

export const Wrapper = styled.div`
  .circle-background,
  .circle-progress {
    fill: none;
  }

  .circle-background {
    stroke: #ddd;
  }

  .circle-progress {
    stroke: var(--brandSecondary);
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .circle-text {
    font-size: ${(props) => props.fontSize || '25px'};
    font-weight: bold;
    fill: var(--brandSecondary);
  }
`;
